module.exports = __webpack_public_path__ + "d4567ffe8fa7af5e8f0c4f035a77aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-yuyu.png
// module id = 591
// module chunks = 30